import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const userReducer = createSlice({
  name: "User",
  initialState: {},
  reducers: {
    setProfile: (
      state: any,
      action: PayloadAction<any>
    ) => {
      state.value = action.payload;
    },
    updateProfile: (state: any, action: PayloadAction<any>) => {
      for ( var property in action.payload ) {
        state.value[property] = action.payload[property]
      }
    },
  },
});

export const UserReducer = userReducer.reducer;
export const UserAction = userReducer.actions;